import { authHeader } from "../helpers";
import { defineConfig } from "../config";

export const userService = {
  login,
  profile,
  logout,
  setInStorage,
  sendMailCodeReset,
  savePassword,
  newPassword,
  registerUser,
  createUser,
  uploadAvatar,
  getAvatar,
  readUser,
  readUserAll,
  getAllRole,
  updateUser,
  deleteUser,
  getColorByType,
  getLabelByType,
  getLocalUserAuthorities,
  loginGuest,
  readsAllByRole,
};

const { apiUrl } = defineConfig.USER_SERVICE;

function getApiPath() {
  return (apiUrl + "/user")
}

function handleLoginResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        // logout();
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function handleResponse(response) {
  return response.text().then((text) => {
    let data;
    try {
      data = text && JSON.parse(text);
    } catch (e) {
      data = text; // Fallback a testo normale se la risposta non è un JSON valido
    }

    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        window.location.replace("/logout?status=unauthorized");
      }

      const error = (data && data.message) || (typeof data === 'string' ? data : response.statusText);
      return Promise.reject(error);
    }

    return data;
  });
}

function handleResponseBlob(response) {
  return response.blob().then(blob => {
    return blob;
  }
  );
}

function getTypesList() {
  return [
    {
      label: "Super Admin",
      value: "ROLE_ADMIN",
      desc: "All permission",
      color: "#e94445",
    },
    {
      label: "Manager",
      value: "ROLE_MANAGER",
      desc: "Manage all company user",
      color: "orange",
    },
    {
      label: "Guest User",
      value: "ROLE_GUEST",
      desc: "Publisher rules",
      color: "cyan",
      // sidebar: true
    },
  ];
}

function getColorByType(type) {
  const types = getTypesList();
  let objType = types.filter((t) => type === t.value);
  const color = objType.length === 1 ? objType[0].color : null;
  return color;
}

function getLabelByType(type) {
  const types = getTypesList();
  let objType = types.filter((t) => type === t.value);
  const label = objType.length === 1 ? objType[0].label : null;
  return label;
}

function getLocalUserAuthorities() {
  let userString = localStorage.getItem("user");
  const user = JSON.parse(userString);
  return user?.principal?.claims?.authorities?.ale || null;
}

function loginGuest(accessToken, guestToken) {
  const auth = "Bearer " + accessToken
  localStorage.setItem("auth", auth);
  localStorage.setItem("guest", guestToken);

  return userService.profile(auth).then(
    user => {
      const resUser = this.setInStorage(user)
      return resUser;
    },
    error => {
      console.error(error);
      return error;
    }
  );
}

function setInStorage(user) {
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("check", 1);
  return user;
}

function registerUser(user) {
  const url = apiUrl + "/prereg/signup";
  const body = JSON.stringify(user);

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body,
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function login(username, password) {
  let formData = new FormData();
  formData.append("username", username);
  formData.append("password", password);
  formData.append("grant_type", "password");

  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: "Basic " + window.btoa("browser:Zzixoigp6R5K35"),
    },
    body: formData,
  };

  return fetch(apiUrl + "/oauth2/token", requestOptions)
    .then(handleLoginResponse)
    .then((response) => {
      if (response) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        const auth = response.token_type + " " + response.access_token;
        const refresh = response.refresh_token;
        localStorage.setItem("auth", auth);
        localStorage.setItem("refresh", refresh);

        return profile(auth).then(
          (user) => {
            if (user.principal.claims.tenants && user.principal.claims.tenants.length === 0) {
              throw new Error("Nessuna organizzazione associata");
            } else {
              this.setInStorage(user);
            }
            return user;
          },
          (error) => {
            console.error(error);
            return error;
          }
        );

      }
    });
}

function logout() {
  localStorage.removeItem("user");
  localStorage.removeItem("type");
  localStorage.removeItem("auth");
  localStorage.removeItem("check");
  localStorage.removeItem("refresh");
}

function profile(auth) {
  let header = {
    Authorization: auth,
  };
  const requestOptions = {
    method: "GET",
    headers: header,
  };

  return fetch(getApiPath() + "/read/profile", requestOptions).then(handleResponse);
}

function sendMailCodeReset(username) {
  const requestOptions = {
    method: "PUT",
    headers: { "content-type": "application/json" },
  };
  return fetch(
    getApiPath() + "/update/forgotPassword/" + username,
    requestOptions
  )
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function savePassword(passwordToken) {
  const url = getApiPath() + "/update/password";

  const requestOptions = {
    method: "PUT",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(passwordToken)
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function newPassword(oldPassword, newPassword) {
  const url = getApiPath() + "/update/password";
  const body = JSON.stringify({
    oldPassword,
    newPassword,
    newPasswordConfirm: newPassword,
  });

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body,
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function createUser(user) {
  const url = getApiPath() + `/create`;
  const body = JSON.stringify(user);

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: body,
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function uploadAvatar(formData) {
  const url = getApiPath() + `/create/avatar`;

  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: formData
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

async function getAvatar(idAvatar) {
  const url = getApiPath() + `/read/avatar/${idAvatar}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  const response = await fetch(url, requestOptions);
  const res = await handleResponseBlob(response);
  return res;
}

function readUser(id) {
  const url = getApiPath() + `/read/${id}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function readUserAll(page, perPage, sortType) {
  const url =
    getApiPath() + `/all/${page}/${perPage}/${sortType}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getAllRole() {
  const url =
    getApiPath() + `/all/role`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function updateUser(body) {
  const url = getApiPath() + `/update/${body?.claims?.userId || body?.id}`;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(body),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function deleteUser(id) {
  const url = getApiPath() + `/delete/${id}`;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function readsAllByRole(role) {
  const url =
    getApiPath() + `/all/` + role;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}